module.exports = __webpack_public_path__ + "static/media/IMG_0981_low.889de8a0.jpg";